export const REVIEW_INCOMING_APPLICATIONS_STUDENT_LOOKUP_FETCHING =
  'REVIEW_INCOMING_APPLICATIONS_STUDENT_LOOKUP_FETCHING';
export const REVIEW_INCOMING_APPLICATIONS_STUDENT_LOOKUP_FETCH_ERROR =
  'REVIEW_INCOMING_APPLICATIONS_STUDENT_LOOKUP_FETCH_ERROR';
export const REVIEW_INCOMING_APPLICATIONS_STUDENT_LOOKUP_SET_STUDENTS =
  'REVIEW_INCOMING_APPLICATIONS_STUDENT_LOOKUP_SET_STUDENTS';



// WEBPACK FOOTER //
// ./src/pages/reviewincomingapplications/state/studentlookup/types.js